/**
 * FocusRipple
 * RippleEffect for onFocus Event
 *
 * @class  FocusRipple
 * @author Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';

export default React.createClass({

	displayName: "FocusRipple",

	propTypes: {
		show: React.PropTypes.bool
	},

	componentDidMount() {
		this._setRippleSize();
	},

	render() {
		let classes = ClassNames('lui-focus-ripple', {
			'lui-is-shown': this.props.show
		});

		return (
			React.createElement("div", {
					className: classes
				},
				React.createElement("div", {
					className: "lui-focus-ripple-inner"
				})
			)
		);
	},

	_setRippleSize() {
		let el = React.findDOMNode(this);
		let height = el.offsetHeight;
		let width = el.offsetWidth;
		let size = Math.max(height, width);

		el.style.height = size + 'px';
		el.style.top = (size / 2 * -1) + (height / 2) + 'px';
	}
});



/** WEBPACK FOOTER **
 ** ./src/components/animations/focus-ripple/FocusRipple.js
 **/